export default class ModalThx {
    constructor() {
        this.init();
    }

    init() {
        this.showModal();
    }

    getParam(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    showModal() {
        const modal = document.querySelector(".js-m-thx");

        if (this.getParam("vote")) {
            setTimeout(() => {
                modal.classList.add("-active");
            }, 500);
        }
    }
}

